const dayNames = {
  ru: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  lv: ['sv', 'pr', 'ot', 'tr', 'ce', 'pk', 'se'],
  lt: ['sek', 'pir', 'ant', 'tre', 'ket', 'pen', 'šeš'],
  pl: ['ndz', 'pon', 'wt', 'śr', 'czw', 'pt', 'sob'],
};

const monthNames = {
  ru: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  lv: ['jan', 'feb', 'mar', 'apr', 'mai', 'jūn', 'jūl', 'aug', 'sep', 'okt', 'nov', 'dec'],
  lt: ['sau', 'vas', 'kov', 'bal', 'geg', 'bir', 'lie', 'rgp', 'rgs', 'spa', 'lap', 'grd'],
  pl: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
};

const monthNamesFull = {
  ru: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  lv: ['janvāra', 'februāra', 'marta', 'aprīļa', 'maija', 'jūnija', 'jūlija', 'augusta', 'septembra', 'oktobra', 'novembra', 'decembra'],
  lt: ['sausio', 'vasario', 'kovo', 'balandžio', 'gegužės', 'birželio', 'liepos', 'rugpjūčio', 'rugsėjo', 'spalio', 'lapkričio', 'gruodžio'],
  pl: ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'],
};

export const formatDateShort = (dateStr, lang = 'ru') => {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  const days = dayNames[lang] || dayNames.en;
  const months = monthNamesFull[lang] || monthNamesFull.en;
  return `${d.getDate()} ${months[d.getMonth()]}, ${days[d.getDay()]}`;
};

export const formatDate = (dateStr, lang = 'ru') => {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  const days = dayNames[lang] || dayNames.en;
  const months = monthNames[lang] || monthNames.en;
  return `${days[d.getDay()]}, ${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
};
